import * as yup from 'yup';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { CaseHandlerResponseDto, UpdateIaCaseEventHandlerDto } from '@bandido/shared/dtos';

const createSchema = (t: TFunction) =>
  yup.object().shape({
    name: yup.string().required(t('common.form.required')),
    description: yup.string().optional(),
    messageContextHistoryCount: yup
      .number()
      .required(t('common.form.required'))
      .min(0, t('common.form.minValue', { value: 0 })),
    enabled: yup.boolean().required(),
    documentation: yup.array(yup.string()).optional(),
    scanWorkflowId: yup.string().optional(),
    channel: yup.string().optional(),
    scanStepId: yup.string().optional(),
    scanStatus: yup.string().optional(),
    // Nuevos campos del IA handler
    handlerPurpose: yup.string().optional(),
    behaviorRules: yup.string().optional(),
    stepsDescription: yup.string().optional(),
    handlerExample: yup.string().optional(),
    conversationExample: yup.string().optional(),
    validations: yup.string().optional(),
    allowedTools: yup.array(yup.string()).optional(),
    additionalNotes: yup.string().optional(),
    nextWorkflowId: yup.string().optional(),
    nextStepId: yup.string().optional(),
    nextStatus: yup.string().optional(),
    onCancelWorkflowId: yup.string().optional(),
    onCancelStepId: yup.string().optional(),
    onCancelStatus: yup.string().optional(),
    onBailoutWorkflowId: yup.string().optional(),
    onBailoutStepId: yup.string().optional(),
    onBailoutStatus: yup.string().optional(),
  });

export type FormSchema = yup.InferType<ReturnType<typeof createSchema>>;

export const useResolver = () => {
  const { t } = useTranslation();
  return yupResolver(createSchema(t));
};

export const getPayload = (formData: CaseHandlerResponseDto): UpdateIaCaseEventHandlerDto => ({
  name: formData.name,
  description: formData.description,
  messageContextHistoryCount: formData.messageContextHistoryCount,
  enabled: formData.enabled,
  documentation: formData.documentation,
  scanWorkflowId: formData.scanWorkflowId,
  channel: formData.channel,
  scanStepId: formData.scanStepId,
  scanStatus: formData.scanStatus,
  // Nuevos campos del IA handler
  handlerPurpose: formData.handlerPurpose,
  behaviorRules: formData.behaviorRules,
  stepsDescription: formData.stepsDescription,
  handlerExample: formData.handlerExample,
  conversationExample: formData.conversationExample,
  validations: formData.validations,
  allowedTools: formData.allowedTools,
  additionalNotes: formData.additionalNotes,
  nextWorkflowId: formData.nextWorkflowId,
  nextStepId: formData.nextStepId,
  nextStatus: formData.nextStatus,
  onCancelWorkflowId: formData.onCancelWorkflowId,
  onCancelStepId: formData.onCancelStepId,
  onCancelStatus: formData.onCancelStatus,
  onBailoutWorkflowId: formData.onBailoutWorkflowId,
  onBailoutStepId: formData.onBailoutStepId,
  onBailoutStatus: formData.onBailoutStatus,
  updatedBy: formData.updatedBy,
});
